/* Add a wrapper around all select elements */


var SideMenu = $('.sideSection');
function openNav() {
    $(SideMenu).width(300);
}

function closeNav() {
    $(SideMenu).width(0);
}
/* Add a wrapper around all select elements */
AOS.init();

$('.lazy').lazy({
    // called before an elements gets handled
    beforeLoad: function (element) {
        var backgroundX = element.data('focus-x');
        var backgroundY = element.data('focus-y');
        var result = String(backgroundX + ' ' + backgroundY);
        element.css('background-position', result);
    },
    effect: 'fadeIn',
    effectTime: 1000,
    threshold: 0
});


$('.multiple-items').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: false,
    swipeToSlide: true,
    prevArrow: '<button class="btn slick-prev  btn-block btn-sm  btn-outline-dark rounded-small mb-3" aria-label="Previous" type="button">Previous</button>',
    nextArrow: '<button class="btn slick-next btn-block btn-sm  btn-outline-dark rounded-small mt-3" aria-label="Next" type="button">Next</button>',
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 3,
                slidesToScroll: 3,
                infinite: true
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 2,
                arrows: true
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true
            }
        }
    ]
});

$('.campaign').slick({
    autoplay:true,
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 2,
    slidesToScroll: 1,
    arrows: false,
    swipeToSlide: true,
    prevArrow: '<button class="btn slick-prev  btn-block btn-sm  btn-outline-dark rounded-small mb-3" aria-label="Previous" type="button">Previous</button>',
    nextArrow: '<button class="btn slick-next btn-block btn-sm  btn-outline-dark rounded-small mt-3" aria-label="Next" type="button">Next</button>',
    responsive: [
        {
            breakpoint: 1024,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                infinite: true
            }
        },
        {
            breakpoint: 600,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                arrows: true
            }
        },
        {
            breakpoint: 480,
            settings: {
                slidesToShow: 1,
                slidesToScroll: 1,
                arrows: true
            }
        }
    ]
});


$("section[data-background]").each(function () {
    var $this = $(this);
    var backgroundColor = '#' + $this.data("background");
    var border = $this.find('.banner-block').first();
    border.css('background-color', backgroundColor);
});

// Smooth scrolling using jQuery easing
$('a.js-scroll-trigger[href*="#"]:not([href="#"])').click(function (e) {
    var elm = this;
    scrollToElm(elm);
});


function scrollToElm(elm) {
    var $this = elm;
    //$('a.js-scroll-trigger[href*="#"]:not([href="#"])').click(function () {
    if (location.pathname.replace(/^\//, '') == $this.pathname.replace(/^\//, '') && location.hostname == $this.hostname) {
        var target = $($this.hash);
        target = target.length ? target : $('[name=' + $this.hash.slice(1) + ']');
        if (target.length) {
            $('html, body').animate({
                scrollTop: (target.offset().top - 125)
            }, 1000, "easeInOutExpo");
            return false;
        }
    }
    //});
}

// Closes responsive menu when a scroll trigger link is clicked
$('.js-scroll-trigger').click(function () {
    $('.navbar-collapse').collapse('hide');
});


baguetteBox.run('.gallery');


$(document).ready(function () {

    var modalVideo = $('#modal-video'),
        smallVideo = $('#myVideo'),
        largeVideo = $('#my-video_html5_api');

    modalVideo.on('shown.bs.modal', function () {
        smallVideo.get(0).pause();
        largeVideo.get(0).play();
    });
    modalVideo.on('hidden.bs.modal', function () {
        smallVideo.get(0).play();
    });

    var sideNavElm = $('#mainMenu');

    var mainMenu = sideNavElm.slideMenu({
        position: 'left',
        //submenuLinkAfter: ' >',
        backLinkBefore: '< '
    });


    /* if ($(window).width() > 767) {
     mainMenu.open(false);
     }*/


// Open navbarSide when button is clicked
    $('#navigationButton').on('click', function () {

        if (sideNavElm.hasClass("reveal")) {
            $(this)
                .find(".fa-times")
                .removeClass("fa-times")
                .addClass("fa-bars");
            sideNavElm.removeClass("reveal");
            mainMenu.close();
            // mod to reset menu on close -- client wanted..
            sideNavElm.find('.slider').css('transform', 'none');

        } else {
            sideNavElm.addClass('reveal');
            mainMenu.open();
            $(this)
                .find(".fa-bars")
                .removeClass("fa-bars")
                .addClass("fa-times");

        }
    });

    $('.reservationButton').on('click', function () {

        var bookNowOffCanvas = $('#book-now-offcanvas');

        if (bookNowOffCanvas.hasClass("reveal")) {
            /*$(this)
             .find(".fa-times")
             .removeClass("fa-times")
             .addClass("fa-bars");*/
            bookNowOffCanvas.removeClass("reveal")
        } else {
            bookNowOffCanvas.addClass('reveal');
            $(this)
                .find(".fa-bars")
                .removeClass("fa-bars")
                .addClass("fa-times");
        }


        //$('.overlay').show();
    });

    $('.collapse')
        .on('shown.bs.collapse', function () {
            $(this)
                .parent()
                .find(".fa-chevron-right")
                .removeClass("fa-chevron-right")
                .addClass("fa-chevron-down");
        })
        .on('hidden.bs.collapse', function () {
            $(this)
                .parent()
                .find(".fa-chevron-down")
                .removeClass("fa-chevron-down")
                .addClass("fa-chevron-right");
        });


//set the reservation forms submission value from the property selected
    var reservationForm = $('#reservationForm');
    var accommodationSelect = $('#accommodationSelect');
    var checkInDate = $("#available_from");
    var checkOutDate = $("#available_to");

    var currentSite = $('body').attr('class');

    accommodationSelect.on('change', function () {
        //console.log('Changed');
        var code = $(this).val();
        //reservationForm.data('channelcode', code);
        //reservationForm.attr('data-channelcode', code);
        reservationForm.attr('action', code);
    });

    // auto select the property dropdown based on the site..
    if (currentSite === 'amity-court') {

        accommodationSelect.val("https://bookingsap.newbook.cloud/amitycourt/index.php").change();
    } else if (currentSite === 'antonio-mews') {
        accommodationSelect.val("https://bookingsap.newbook.cloud/antoniomews/index.php").change();
    }
    //console.log(currentSite);

    /*var code = accommodationSelect.val();
     console.log(currentSite);
     reservationForm.data('channelcode', code);*/


    reservationForm.submit(function (event) {
        if (accommodationSelect.val() === '') {
            $('.invalid-feedback').show();
            event.preventDefault();
        } else {
            $('.invalid-feedback').hide();
            reservationForm.addClass('was-validated');
        }
    });

    jqueryDatepicker($);
    var date = new Date();
    var currentMonth = date.getMonth();
    var currentDate = date.getDate();
    var currentYear = date.getFullYear();
    checkInDate.datepicker(
        {
            dateFormat: 'dd M yy',
            //comment the beforeShow handler if you want to see the ugly overlay
            beforeShow: function () {
                setTimeout(function () {
                    $('.ui-datepicker').css('z-index', 9999);
                }, 0);
            },
            onSelect: function (date, inst) {
                var selDate = new Date(date);
                var newDate = new Date(selDate.getFullYear(), selDate.getMonth(), selDate.getDate() + 1);
                checkOutDate.datepicker('option', 'minDate', newDate);
            },
            minDate: new Date(currentYear, currentMonth, currentDate)
        }
    );
    checkInDate.datepicker('setDate', new Date());
    checkOutDate.datepicker(
        {
            dateFormat: 'dd M yy',
            //comment the beforeShow handler if you want to see the ugly overlay
            beforeShow: function () {
                setTimeout(function () {
                    $('.ui-datepicker').css('z-index', 9999);
                }, 0);
            },
            onSelect: function (date, inst) {
            }
        }
    );
    checkOutDate.datepicker('setDate', new Date());
    // Custom
    var stickyToggle = function (sticky, stickyWrapper, scrollElement) {
        var stickyHeight = sticky.outerHeight();
        var stickyTop = stickyWrapper.offset().top;
        if (scrollElement.scrollTop() >= stickyTop) {
            stickyWrapper.height(stickyHeight);
            sticky.addClass("is-sticky");
        }
        else {
            sticky.removeClass("is-sticky");
            stickyWrapper.height('auto');
        }
    };

    // Find all data-toggle="sticky-onscroll" elements
    $('[data-toggle="sticky-onscroll"]').each(function () {
        var sticky = $(this);
        var stickyWrapper = $('<div>').addClass('sticky-wrapper'); // insert hidden element to maintain actual top offset on page
        sticky.before(stickyWrapper);
        sticky.addClass('sticky');

        // Scroll & resize events
        $(window).on('scroll.sticky-onscroll resize.sticky-onscroll', function () {
            stickyToggle(sticky, stickyWrapper, $(this));
        });

        // On page load
        stickyToggle(sticky, stickyWrapper, $(window));
    });


//submit a form automatically when input(s) are changed
// post-submit callback
    var showResponse = function (responseText, statusText, xhr, $form) {
        // for normal html responses, the first argument to the success callback
        // is the XMLHttpRequest object's responseText property

        // if the ajaxForm method was passed an Options Object with the dataType
        // property set to 'xml' then the first argument to the success callback
        // is the XMLHttpRequest object's responseXML property

        // if the ajaxForm method was passed an Options Object with the dataType
        // property set to 'json' then the first argument to the success callback
        // is the json data object returned by the server
        if ($('#Form_Form').length) {
            $('#Form_Form').hide();
        }
        if ($('#ContactForm_ContactForm').length) {
            $('#ContactForm_ContactForm').hide();
        }
    };


    var options = {
        target: '#response',
        success: showResponse  // post-submit callback
    };
    $('#Form_Form').ajaxForm(options);
    $('#ContactForm_ContactForm').ajaxForm(options);


    var searchInput = $('.dynamic-search');
    var searchForm = $('.search-form');


    searchForm.submit(function (event) {
        var noSuggestion = $('.autocomplete-no-suggestion');
        //console.log('checking..');
        if (noSuggestion.length) {
            //console.log('no results..');
            event.preventDefault();
        }
    });


    //$(searchInput).attr('type');

    searchInput.autocomplete({
        serviceUrl: 'json/fullsearch',
        onSearchStart: function (params) {
            params.type = $(this).attr('data-type');
            params.SubsiteID = $(this).attr('data-siteID');
        },
        //params: {'Type': $(this).attr('type')},
        showNoSuggestionNotice: true,
        autoSelectFirst: true,
        groupBy: 'category',
        onSelect: function (suggestion) {
            //console.log(suggestion);
            var url = suggestion.data.urlLink;
            window.location.replace(url);
        }/*,
         formatResult: function (suggestion, currentValue) {
         return '<div class="row ">' +
         '<div class="col col-md-2 show-list-col show-list-image-col">' +
         '<img class="img-responsive" src="' + suggestion.icon + '" >' +
         '</div>' +
         '<div class="col col-md-10 show-list-col show-list-info-col">' +
         '<div class="row show-list-info-row">' +
         '<div class="col-12">' + '<h2>' + suggestion.name + '</h2>' + suggestion.desc + '</div>' +
         '</div>' +
         '</div>' +
         '</div>' +
         '<div style="clear:both;"></div>';
         }*/
    });


// overlay exansions
    // $(document).ready(function () {
    /*
     if ($('.my-shuffle').length) {
     */


    /*   var Shuffle = window.Shuffle;

     var myShuffle = new Shuffle(document.querySelector('.my-shuffle'), {
     itemSelector: '.image-item',
     sizer: '.my-sizer-element',
     buffer: 1
     });

     $('input[name="shuffle-filter"]').on('change', function (evt) {
     var input = evt.currentTarget;
     if (input.checked) {
     myShuffle.filter(input.value);
     }
     });*/
    // }


});


var Shuffle = window.Shuffle;


var Demo = function (element) {
// Log out events.
    this.tags = Array.from(document.querySelectorAll('.js-tags input'));
    this.ratings = Array.from(document.querySelectorAll('.js-ratings input'));
    this.grades = Array.from(document.querySelectorAll('.js-grades input'));
    this.styles = Array.from(document.querySelectorAll('.js-styles input'));
    this.prices = Array.from(document.querySelectorAll('.js-prices input'));
    this.seasons = Array.from(document.querySelectorAll('.js-seasons input'));

    this.shuffle = new Shuffle(element, {
        itemSelector: '.image-item',
        sizer: '.my-sizer-element',
        buffer: 1
    });

    this.shuffle.on(Shuffle.EventType.LAYOUT, function () {
        /* console.log('Things finished moving!');*/
        // $('.card-body').matchHeight();
        $('.card-body').matchHeight();
    });

    this.filters = {
        tags: [],
        ratings: [],
        grades: [],
        styles: [],
        prices: [],
        seasons: []
    };

    this._bindEventListeners();
};


/**
 * Bind event listeners for when the filters change.
 */
Demo.prototype._bindEventListeners = function () {


    this._onTagChange = this._handleTagsChange.bind(this);
    this._onGradeChange = this._handleGradesChange.bind(this);
    this._onRatingChange = this._handleRatingsChange.bind(this);
    this._onStyleChange = this._handleStylesChange.bind(this);
    this._onPriceChange = this._handlePricesChange.bind(this);
    this._onSeasonChange = this._handleSeasonsChange.bind(this);

    this.tags.forEach(function (input) {
        input.addEventListener('change', this._onTagChange);
    }, this);
    this.grades.forEach(function (input) {
        input.addEventListener('change', this._onGradeChange);
    }, this);
    this.ratings.forEach(function (input) {
        input.addEventListener('change', this._onRatingChange);
    }, this);
    this.styles.forEach(function (input) {
        input.addEventListener('change', this._onStyleChange);
    }, this);
    this.prices.forEach(function (input) {
        input.addEventListener('change', this._onPriceChange);
    }, this);
    this.seasons.forEach(function (input) {
        input.addEventListener('change', this._onSeasonChange);
    }, this);



};

/**
 * Get the values of each checked input.
 * @return {Array.<string>}
 */
Demo.prototype._getCurrentTagsFilters = function () {
    return this.tags.filter(function (input) {
        return input.checked;
    }).map(function (input) {
        return input.value;
    });
};

Demo.prototype._getCurrentStylesFilters = function () {
    return this.styles.filter(function (input) {
        return input.checked;
    }).map(function (input) {
        return input.value;
    });
};
Demo.prototype._getCurrentGradesFilters = function () {
    return this.grades.filter(function (input) {
        return input.checked;
    }).map(function (input) {
        return input.value;
    });
};
Demo.prototype._getCurrentRatingsFilters = function () {
    return this.ratings.filter(function (input) {
        return input.checked;
    }).map(function (input) {
        return input.value;
    });
};

Demo.prototype._getCurrentPricesFilters = function () {
    return this.prices.filter(function (input) {
        return input.checked;
    }).map(function (input) {
        return input.value;
    });
};

Demo.prototype._getCurrentSeasonsFilters = function () {
    return this.seasons.filter(function (input) {
        return input.checked;
    }).map(function (input) {
        return input.value;
    });
};


/*Demo.prototype._getCurrentRatingsFilters = function () {
 return this.ratings.filter(function (button) {
 return button.classList.contains('active');
 }).map(function (button) {
 return button.getAttribute('data-value');
 });
 };

 Demo.prototype._getCurrentGradesFilters = function () {
 return this.grades.filter(function (button) {
 return button.classList.contains('active');
 }).map(function (button) {
 return button.getAttribute('data-value');
 });
 };

 Demo.prototype._getCurrentStylesFilters = function () {
 return this.grades.filter(function (button) {
 return button.classList.contains('active');
 }).map(function (button) {
 return button.getAttribute('data-value');
 });
 };*/

/**
 * A shape input check state changed, update the current filters and filte.r
 */
Demo.prototype._handleTagsChange = function () {
    this.filters.tags = this._getCurrentTagsFilters();
    this.filter();
};

Demo.prototype._handleRatingsChange = function () {
    this.filters.ratings = this._getCurrentRatingsFilters();
    this.filter();
};

Demo.prototype._handleGradesChange = function () {
    this.filters.grades = this._getCurrentGradesFilters();
    this.filter();
};

Demo.prototype._handleStylesChange = function () {
    this.filters.styles = this._getCurrentStylesFilters();
    this.filter();
};

Demo.prototype._handlePricesChange = function () {
    this.filters.prices = this._getCurrentPricesFilters();
    this.filter();
};

Demo.prototype._handleSeasonsChange = function () {
    this.filters.seasons = this._getCurrentSeasonsFilters();
    this.filter();
};


/**
 * A color button was clicked. Update filters and display.
 * @param {Event} evt Click event object.
 Demo.prototype._handleColorChange = function (evt) {
    var button = evt.currentTarget;

    // Treat these buttons like radio buttons where only 1 can be selected.
    if (button.classList.contains('active')) {
        button.classList.remove('active');
    } else {
        this.colors.forEach(function (btn) {
            btn.classList.remove('active');
        });

        button.classList.add('active');
    }

    this.filters.colors = this._getCurrentColorFilters();
    this.filter();
};*/

/**
 * Filter shuffle based on the current state of filters.
 */
Demo.prototype.filter = function () {

    if (this.hasActiveFilters()) {
        this.shuffle.filter(this.itemPassesFilters.bind(this));
    } else {
        this.shuffle.filter(Shuffle.ALL_ITEMS);
    }

};

/**
 * If any of the arrays in the `filters` property have a length of more than zero,
 * that means there is an active filter.
 * @return {boolean}
 */
Demo.prototype.hasActiveFilters = function () {
    return Object.keys(this.filters).some(function (key) {
        return this.filters[key].length > 0;
    }, this);
};

/**
 * Determine whether an element passes the current filters.
 * @param {Element} element Element to test.
 * @return {boolean} Whether it satisfies all current filters.
 */
Demo.prototype.itemPassesFilters = function (element) {
    var tags = this.filters.tags;
    var grades = this.filters.grades;
    var ratings = this.filters.ratings;
    var styles = this.filters.styles;
    var priceranges = this.filters.prices;
    var seasons = this.filters.seasons;
    var tag = $(element).data('tag');
    var grade = $(element).data('grade');
    var rating = $(element).data('rating');
    var style = $(element).data('style');
    var price = $(element).data('price');
    var season = $(element).data('season');

    var tagFilter = [];
    var styleFilter = [];
    var gradeFilter = [];
    var ratingsFilter = [];
    var priceFilter = [];
    var seasonFilter = [];

    if (tags.length) {
        for (var a = 0; a < tag.length; a++) {
            var indTag = tag[a];
            if (!arrayIncludes(tags, indTag)) {
                tagFilter.push(false);
            } else {
                tagFilter.push(true);
            }
        }
    }


    if (styles.length) {
        for (var b = 0; b < style.length; b++) {
            var indStyle = style[b];
            if (!arrayIncludes(styles, indStyle)) {
                styleFilter.push(false);
            } else {
                styleFilter.push(true);
            }
        }
    }


    if (grades.length) {
        for (var c = 0; c < grade.length; c++) {
            var indGrade = grade[c];
            if (!arrayIncludes(grades, indGrade)) {
                gradeFilter.push(false);
            } else {
                gradeFilter.push(true);
            }
        }
    }



    /*  if (ratings.length > 0 && !arrayIncludes(ratings, rating)) {
     return false;
     }*/

    if (ratings.length) {
        for (var d = 0; d < rating.length; d++) {
            var indRating = rating[d];
            if (!arrayIncludes(ratings, indRating)) {
                ratingsFilter.push(false);
            } else {
                ratingsFilter.push(true);
            }
        }
    }

    if (priceranges.length) {
        for (var e = 0; e < price.length; e++) {
            var indPrice = price[e];
            if (!arrayIncludes(priceranges, indPrice)) {
                priceFilter.push(false);
            } else {
                priceFilter.push(true);
            }
        }
    }

    if (seasons.length) {
        for (var d = 0; d < season.length; d++) {
            var indSeason = season[d];
            if (!arrayIncludes(seasons, indSeason)) {
                seasonFilter.push(false);
            } else {
                seasonFilter.push(true);
            }
        }
    }
    /*
    // If there are active shape filters and this shape is not in that array.
    if (tags.length > 0 && !tags.includes(tag)) {
        return false;
    }
    if (priceranges.length > 0 && !priceranges.includes(indPrice)) {
        return false;
    }
     */


    /*if ( (!arrayIncludes(tagFilter, true)) && (!arrayIncludes(styleFilter, true)) && (!arrayIncludes(gradeFilter, true)) && (!arrayIncludes(ratingsFilter, true)) && (!arrayIncludes(priceFilter, true)) && (!arrayIncludes(seasonFilter, true))) {
        return false;
    }*/

    // If there are active shape filters and this shape is not in that array.
    if (tagFilter.length > 0 && !arrayIncludes(tagFilter, true)) {
        return false;
    }
    if (styleFilter.length > 0 && !arrayIncludes(styleFilter, true)) {
        return false;
    }
    if (gradeFilter.length > 0 && !arrayIncludes(gradeFilter, true)) {
        return false;
    }
    if (ratingsFilter.length > 0 && !arrayIncludes(ratingsFilter, true)) {
        return false;
    }
    if (priceFilter.length > 0 && !arrayIncludes(priceFilter, true)) {
        return false;
    }
    if (seasonFilter.length > 0 && !arrayIncludes(seasonFilter, true)) {
        return false;
    }


    return true


};


document.addEventListener('DOMContentLoaded', function () {
    if ($('.my-shuffle').length) {
        window.demo = new Demo(document.querySelector('.my-shuffle'));
    }
});


Array.prototype.allValuesSame = function () {
    for (var i = 1; i < this.length; i++) {
        if (this[i] !== this[0])
            return false;
    }
    return true;
}

// ES7 will have Array.prototype.includes.
function arrayIncludes(array, value) {
    return array.indexOf(value) !== -1;
}

// Convert an array-like object to a real array.
function toArray(thing) {
    return Array.prototype.slice.call(thing);
}


$(function() {
    return $("#carouselHeaderBanner").on("slide.bs.carousel", function(ev) {
        $(".lazy").lazy();
    });
});

$(window).on('scroll', function () {
    if ($(this).scrollTop() > 70) { // Set position from top
        $('#menulogo').fadeIn();
        //$('.navbar-brand  img').attr('src', 'images/logo.png');
    }else{
        $('#menulogo').fadeOut();
        //$('.navbar-brand  img').attr('src', 'images/logo.png');
    }
});
